<ng-container
	*ngIf="packageResults_()?.matterPackages?.length > 0; else emptyTable"
>
	<div [uiColSpan]="12">
		<div class="overflow-auto rounded-2xl border border-gray-200">
			<table class="w-full divide-y divide-gray-200 table-fixed p-sm">
				<colgroup>
					<col class="w-5/12" />
					<col class="w-1/6" />
					<col class="w-1/6" />
					<col class="w-1/6" />
					<col class="w-1/12" />
				</colgroup>
				<thead class="bg-gray-200 h6 text-gray-700">
					<tr class="*:px-4 *:py-3 *:bg-gray-100 *:font-medium *:text-left">
						<th>
							<button
								class="flex items-center gap-2 hover:text-green-600 focus:outline-none"
								[class.text-green-600]="viewModel.sortDirections().packageName"
								(click)="onSort('packageName')"
							>
								Package Name
								<ng-container
									*ngTemplateOutlet="
										sortingIcon;
										context: {
											sorting: viewModel.sortDirections().packageName,
										}
									"
								></ng-container>
							</button>
						</th>
						<th>Type</th>
						<th>Status</th>
						<th>
							<button
								class="flex items-center gap-2 hover:text-green-600 focus:outline-none"
								[class.text-green-600]="viewModel.sortDirections().lastUpdated"
								(click)="onSort('lastUpdated')"
							>
								Last Updated
								<ng-container
									*ngTemplateOutlet="
										sortingIcon;
										context: {
											sorting: viewModel.sortDirections().lastUpdated,
										}
									"
								></ng-container>
							</button>
						</th>
						<th class="text-right">&nbsp;</th>
					</tr>
				</thead>
				<tbody class="bg-white divide-y divide-gray-200 p-sm text-gray-950">
					<ng-container
						*ngFor="
							let package of mergedPackagesWithEnvelopes_();
							let isFirst = first
						"
					>
						<tr
							class="*:align-middle group hover:bg-gray-50 cursor-pointer *:px-4 *:py-3"
							(click)="
								editingNamePackageId_() !== package.id &&
									gotoEditPackage(package.id)
							"
						>
							<td class="truncate min-w-fit">
								<div class="flex items-center gap-2 truncate">
									<img
										[src]="package | packageIcon: false"
										class="w-9 h-9"
										alt="Package icon"
									/>
									@if (editingNamePackageId_() === package.id) {
										<input
											#packageNameInput
											type="text"
											[value]="package.packageName"
											(blur)="
												onPackageNameBlur(
													package.id,
													package.packageName,
													packageNameInput.value
												)
											"
											(keydown.enter)="
												onPackageNameEnter(
													package.id,
													package.packageName,
													packageNameInput.value
												)
											"
											(keydown.escape)="toggleEditingName(null)"
											class="truncate block border border-green-600 rounded px-2 py-1 focus:outline-none focus:ring-2 focus:ring-green-600 w-full"
											(click)="$event.stopPropagation()"
											[id]="'package-name-input-' + package.id"
										/>
									} @else {
										<span
											class="truncate block"
											(click)="gotoEditPackage(package.id)"
											>{{ package.packageName }}</span
										>
									}
								</div>
							</td>
							<td>
								@if (isSignItEnabled_()) {
									<app-matter-package-type
										[packageTypes_]="package.packageTypes"
										[packageId_]="package.id"
									/>
								} @else {
									<app-matter-package-history-button
										[packageId_]="package.id"
										[dataIntercomTarget_]="
											isFirst
												? 'documents-packages-page-package-history-button'
												: null
										"
										[date_]="package.lastUpdatedAt || package.createdAt"
									/>
								}
							</td>
							<td>
								<ui-status
									[status]="
										package.packageTypes?.[isSigningPackageKey] &&
										package.envelope
											? package.envelope?.status
											: STATUSES.DRAFT
									"
								/>
							</td>
							<td>
								{{
									package.lastUpdatedAt || package.createdAt
										| date: 'MMM dd, yyy'
								}}
							</td>
							<td
								class="flex justify-end whitespace-nowrap min-w-fit"
								(click)="$event.stopPropagation()"
							>
								@if (!!package.envelope) {
									<app-e-signing-status-actions-dropdown
										size="md"
										[status]="package.envelope?.status"
										[envelopeId]="package.envelope?.id"
										(renameClick)="toggleEditingName(package.id)"
									/>
								} @else {
									<ui-dropdown [items]="packageDropdownItems_()?.[package.id]">
										<ui-button
											icon="dots-vertical"
											preset="EXTRA_LOW_EMPHASIS"
										/>
									</ui-dropdown>
								}
							</td>
						</tr>
					</ng-container>
				</tbody>
			</table>
		</div>
	</div>
</ng-container>

<ng-container *ngIf="isSuggestedPackagesEnabled_()">
	<div class="pt-8 pb-2">
		<h5 class="h5">Suggested Packages</h5>
	</div>

	<ng-container
		*ngIf="
			packageResults_()?.displayVirtualPackages?.length > 0;
			else emptyTableVirtual
		"
	>
		<div [uiColSpan]="12">
			<div class="w-full flex flex-col gap-2">
				<ng-container
					*ngFor="
						let package of packageResults_()?.displayVirtualPackages;
						let isFirst = first
					"
				>
					<div
						class="cursor-pointer rounded-2xl border border-gray-200 bg-white overflow-auto"
					>
						<div
							class="duration-300 border-gray-200"
							[ngClass]="{
								'border-b': expandedPackages_()[package.id],
								'border-0': !expandedPackages_()[package.id],
							}"
						>
							<ui-list-item
								[title]="package.packageName"
								(click)="gotoEditPackage(package.id); $event.stopPropagation()"
								(dblclick)="
									gotoEditPackage(package.id); $event.stopPropagation()
								"
								[listView]="true"
								[isEditingTitle]="editingNamePackageId_() === package.id"
								(titleChange)="updatePackageName(package.id, $event)"
								(titleBlur)="toggleEditingName(null)"
								class="group"
								[testHook]="testHooks.PackagePackageNameListItem"
							>
								<div pre-title class="relative flex items-center gap-2">
									<ui-button
										icon="chevron-down"
										[flipIcon]="expandedPackages_()[package.id] ? null : 90"
										preset="EXTRA_LOW_EMPHASIS"
										(click)="toggleExpand(package); $event.stopPropagation()"
										class="opacity-0 group-hover:opacity-100 transition-opacity duration-300 z-20 relative"
										[testHook]="testHooks.Button"
									/>
									<img
										[src]="
											package | packageIcon: expandedPackages_()[package.id]
										"
										class="w-9 h-9 absolute top-0 left-0 z-10"
										alt="Package icon"
									/>
								</div>
								<div secondary-content>
									@if (!isSignItEnabled_()) {
										<app-matter-package-history-button
											[packageId_]="package.id"
											[dataIntercomTarget_]="
												isFirst
													? 'documents-packages-page-package-history-button'
													: null
											"
											[date_]="package.lastUpdatedAt || package.createdAt"
											[testHook]="testHooks.Button1"
										/>
									}
								</div>
								<div actions class="flex gap-2">
									<ui-button
										icon="file-type-pdf"
										preset="EXTRA_LOW_EMPHASIS"
										(click)="
											exportPackage(package.id); $event.stopPropagation()
										"
										[loading]="package.isExporting"
										label="Export as PDF"
										[testHook]="testHooks.ExportAsPdfButton"
									/>
									<ui-dropdown
										[items]="packageDropdownItems_()?.[package.id]"
										[testHook]="testHooks.Dropdown"
									>
										<ui-button
											icon="dots-vertical"
											preset="EXTRA_LOW_EMPHASIS"
											[testHook]="testHooks.Button2"
										/>
									</ui-dropdown>
								</div>
							</ui-list-item>
						</div>
						<div
							class="col-span-12 duration-300 grid grid-rows-[0fr]"
							[ngClass]="{
								'grid-rows-[1fr]': expandedPackages_()[package.id],
							}"
						>
							<div
								class="overflow-hidden flex flex-col divide-y divide-gray-200"
							>
								<ng-container
									*ngIf="package.documents.length > 0; else noDocuments"
								>
									<ng-container
										*ngFor="
											let docMeta of package.documents;
											trackBy: trackByFn
										"
									>
										<ui-doc-list-item
											[listView]="true"
											[documentMetadata]="docMeta"
											[currentPackageId]="package.id"
											(documentClick)="gotoEditPackage(package.id, docMeta.id)"
											(openDocumentInWord)="onOpenDocumentInWord(docMeta)"
											[analyticContext]="ANALYTIC_CONTEXT.MATTER_PACKAGES"
											[includeInDropdown]="[
												'export',
												'rename',
												'duplicate',
												'reset',
											]"
											[customDropdownItems]="
												documentDropdownItems_()?.[docMeta.id]
											"
											[testHook]="testHooks.DocListItem"
										></ui-doc-list-item>
									</ng-container>
								</ng-container>
							</div>
						</div>
						<ng-template #noDocuments>
							<div
								class="p-6 flex flex-col gap-2 text-gray-500 justify-center items-center"
							>
								<p class="p-sm">No documents in this package</p>
							</div>
						</ng-template>
					</div>
				</ng-container>
			</div>
		</div>
	</ng-container>

	<ng-template #emptyTableVirtual>
		<div
			[uiColSpan]="12"
			class="flex flex-col gap-y-4 bg-white rounded-2xl px-8 pt-20"
		>
			<div class="text-center flex flex-col gap-y-2 pb-20 max-w-500 mx-auto">
				<p class="p-sm text-gray-700 leading-relaxed">
					No suggestions right now
				</p>
			</div>
		</div>
	</ng-template>
</ng-container>

<ng-template #emptyTable>
	<div
		[uiColSpan]="12"
		class="flex flex-col gap-y-4 bg-white rounded-2xl px-8 pt-20"
	>
		<img
			class="h-36 mx-auto mb-6"
			src="/assets/images/documents/empty-packages.svg"
			alt="No packages created yet"
		/>
		<div class="text-center flex flex-col gap-y-2 pb-20 max-w-500 mx-auto">
			<h4 class="h4 mb-0">Select 'Add' to create your first package!</h4>
			<p class="p-sm text-gray-700 leading-relaxed">
				Packages can be used to prepare multiple documents for tasks like a
				Signing Appointment or Final Report.
			</p>
		</div>
	</div>
</ng-template>

<ng-template #sortingIcon let-sorting="sorting">
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="16"
		height="16"
		viewBox="0 0 24 24"
		fill="none"
		stroke="currentColor"
		stroke-width="2"
		stroke-linecap="round"
		stroke-linejoin="round"
		class="icon icon-tabler icons-tabler-outline icon-tabler-selector"
	>
		<path stroke="none" d="M0 0h24v24H0z" fill="none" />
		<path
			d="M8 9l4 -4l4 4"
			[ngClass]="{
				'text-green-600': sorting === 'asc',
				'text-gray-300': sorting === 'desc',
			}"
		/>
		<path
			d="M16 15l-4 4l-4 -4"
			[ngClass]="{
				'text-green-600': sorting === 'desc',
				'text-gray-300': sorting === 'asc',
			}"
		/>
	</svg>
</ng-template>
